<template>
  <div v-if="images.length" :class="['problem-photo-gallery',{compact}]">
    <div class="problem-photo-mobile">
    <button type="button" class="problem-photo-main" :aria-label="text(afterRepair?'ขยายภาพหลังซ่อม':'ขยายภาพปัญหา',afterRepair?'Enlarge after-repair photo':'Enlarge problem photo')" @click="$emit('open',activeImage)">
      <img :src="imageUrl(activeImage)" class="img-fluid rounded border" :style="compact ? {maxHeight:'220px',objectFit:'contain'} : {}" :alt="photoLabel" @error="$emit('error',$event)">
    </button>
    <div v-if="images.length>1" class="d-flex align-items-center mt-2 problem-photo-thumbnails">
      <button v-for="(image,index) in images" :key="image+index" type="button" class="btn p-0 border problem-photo-thumbnail" :class="{'border-primary shadow-sm':activeIndex===index,'opacity-75':activeIndex!==index}" :aria-label="text('เลือกรูปที่ ','Select photo ')+(index+1)" :aria-pressed="activeIndex===index" @click.stop="$emit('input',index)">
        <img :src="imageUrl(image)" :alt="photoLabel+' '+(index+1)" @error="$emit('error',$event)">
      </button>
      <span class="badge badge-light border text-muted small ml-1">{{ activeIndex+1 }}/{{ images.length }}</span>
    </div>
    </div>
    <div class="problem-photo-desktop" :class="{single:images.length===1}">
      <button v-for="(image,index) in images" :key="image+index" type="button" class="problem-photo-full" :aria-label="text('ขยายภาพ ','Enlarge ')+photoLabel+' '+(index+1)" @click="$emit('open',image)">
        <img :src="imageUrl(image)" class="rounded border" :alt="photoLabel+' '+(index+1)" @error="$emit('error',$event)">
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name:'ProblemPhotoGallery',
  props:{images:{type:Array,default:()=>[]},imageUrl:{type:Function,required:true},value:{type:Number,default:0},compact:{type:Boolean,default:false},afterRepair:{type:Boolean,default:false}},
  computed:{photoLabel(){return this.afterRepair?this.text('ภาพหลังซ่อม','After repair photo'):this.text('ภาพปัญหาก่อนซ่อม','Problem photo before repair');},activeIndex(){return Math.max(0,Math.min(this.value,this.images.length-1));},activeImage(){return this.images[this.activeIndex];}},
  methods:{text(th,en){return this.$store?.state?.locale?.lang==='en'?en:th;}}
};
</script>
<style scoped>
.problem-photo-main{display:block;max-width:380px;background:transparent;border:0;padding:0;cursor:pointer;text-align:left}
.problem-photo-thumbnails{gap:8px;flex-wrap:wrap}
.problem-photo-thumbnail{width:52px;height:40px;overflow:hidden;border-radius:4px;border-width:2px!important}
.problem-photo-thumbnail img{width:100%;height:100%;object-fit:cover}
.problem-photo-main:focus-visible,.problem-photo-thumbnail:focus-visible{outline:2px solid #1e40af;outline-offset:3px}
.problem-photo-desktop{display:none}
.problem-photo-main{max-width:100%}
.problem-photo-main img{max-height:380px;object-fit:contain}
.problem-photo-full{padding:0;border:0;background:transparent;cursor:pointer;min-width:0}
.problem-photo-full img{width:100%;height:clamp(160px,22vw,280px);object-fit:contain;background:#f8fafc}
.compact .problem-photo-full img{max-height:220px}
.problem-photo-full:focus-visible{outline:2px solid #1e40af;outline-offset:3px}
@media(min-width:768px){
  .problem-photo-mobile{display:none}
  .problem-photo-desktop{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(180px,100%),1fr));gap:12px}
  .problem-photo-desktop.single{max-width:380px}
}
</style>
